import { useQuery } from '@apollo/client';
import React, { useState } from 'react'
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { GET_USERNAME_BY_EMAIL } from '../../helpers/graphqlQueries';

export default function RedirectToProfileByEmail(){
  let history = useHistory();
  let { id } = useParams();
  const {data} = useQuery(GET_USERNAME_BY_EMAIL,{variables:{email:id},onCompleted});
  const [searching, setSearching] = useState(true);

  function onCompleted(data) {
    console.log(data?.user_account[0]?.username)  
    const username = data?.user_account[0]?.username ;
    if(username){
      history.replace(`/home/${username}`)
    }else{
      history.replace(`/`)
    }
  }

  return (
    <Container>
      <Label>
        Redirecting...
      </Label>
    </Container>
  )
}

const Container = styled.div`
  min-height: 200px;
  display:flex;
  align-items: center;
  justify-content: center;
`;
const Label = styled.label`
  font-size: 24px;
  font-weight: 500;
`;